import React from "react";
import { DivColumn, ParagraphText } from "../../../styles/SharedStyles";
import ConstantsImages from "../../../constants/ConstantsImages";
import ConstantsTexts from "../../../constants/ConstantsTexts";
import WidgetIconFive from "../../icons/widget-icon-five/WidgetIconFive";

import "./WidgetFrozenVersionBadge.css";

const WidgetFrozenVersionBadge = ({ variant = "default" }) => {
  const className =
    variant === "onDark" ? "frozen-version-badge frozen-version-badge--on-dark" : "frozen-version-badge";

  return (
    <DivColumn className={className}>
      <WidgetIconFive
        iconProp={ConstantsImages.FROZEN_VERSION_BADGE_IMAGE}
        widthIconProp="1.9rem"
        heightIconProp="1.9rem"
      />
      <ParagraphText className="frozen-version-badge-text">
        {ConstantsTexts.CODE_249}
        <br />
        {ConstantsTexts.CODE_250}
      </ParagraphText>
    </DivColumn>
  );
};

export default WidgetFrozenVersionBadge;
